import { BehaviorSubject } from 'rxjs';

const stepperToggle = new BehaviorSubject(true);

export const messageService = {
    sendstepperToggle: data => stepperToggle.next({ data: data }),
    getstepperToggle: () => stepperToggle.asObservable()
};